<template>
    <div class="left-category">
        <el-collapse v-if="currentBookType.key === 'base'" class="category" v-model="activeNames">
            <el-collapse-item title="文献年份" name="1">
                <div v-for="(item, index) of recordsByYear" :key="index" class="category-item">
                    <div>{{item.type}}</div>
                    <div>{{item.count}}</div>
                </div>
            </el-collapse-item>
        </el-collapse>
        <el-collapse class="category" v-model="activeNames">
            <el-collapse-item title="文献名称" name="2">
                <div class="items">
                    <div v-for="(item, index) of recordsList" :key="index" class="category-item">
                        <div class="title" @click="goToPage(item)">{{item.title}}</div>
                    </div>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import statisticsApi from '@/api/statistics'
import bookApi from '@/api/ancient'

export default {
    data () {
        return {
            activeNames: ['1', '2'],
            currentBookType: {},
            recordsByYear: [],
            recordsByType: []
        }
    },
    mounted () {},
    methods: {
        getSubItemStatistics () {
            let that = this;

            that.recordsByType = [];
            if (this.currentBookType.key === 'person' || this.currentBookType.key === 'geo') {
                return;
            }

            statisticsApi.getSubItemTypeStatistics({
                type: 'ancient',
                subType: this.currentBookType.key,
                libraryCode: this.global.getLibraryInfos().code

            }).then(response => {
                console.log(response);
                if (response.code === 200) {
                    that.recordsByType = response.data;
                    // that.total = response.data.count;
                    // that.records = response.data.rows;
                }
            })
        },
        getItemStatisticsByYear () {
            let that = this;

            statisticsApi.getItemStatisticsByYear({
                type: 'ancient',
                libraryCode: this.global.getLibraryInfos().code

            }).then(response => {
                console.log(response);
                if (response.code === 200) {
                    that.recordsByYear = response.data;
                    for (let item of that.recordsByYear) {
                        if (item.type === '') {
                            item.type = '其他';
                        }
                    }
                    // that.total = response.data.count;
                    // that.records = response.data.rows;
                }
            })
        },
         getItemList () {
            this.recordsList = [];
            let that = this;

            bookApi.getBook({
                path: 'getAncientBase',
                pageindex: 1,
                pageSize: 9999,
                libraryCode: this.global.getLibraryInfos().code

            }).then(response => {
                console.log(response);
                if (response.code === 200) {
                    that.total = response.data.count;
                    that.recordsList = response.data.rows;
                }
            })
        },
        changeBookSelect (item) {
            this.currentBookType = item;
            this.getSubItemStatistics();
            this.getItemList();
            if (item.key === 'base') {
                this.getItemStatisticsByYear();
            }
        },
          goToPage (item) {
            let routeData = this.$router.resolve({
                path: '/ancientDetail',
                query: {
                    bookId: item.sourceID
                }
            });

            // 必要操作，否则不会打开新页面
            window.open(routeData.href, '_blank');
        }
    }
};
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.left-category {
    width: 280 * @uw;
    height: auto;
    // margin-top: 60px;
    // box-shadow: 0px 0px 10px 5px #e0e0e0;
    // padding-left: 10 * @uw;
    // padding-right: 10 * @uw;
    // height: 50 *@uw;
    // background: bisque;

    .category {
        box-shadow: 0px 0px 10px 5px #e0e0e0;
        padding-left: 10 * @uw;
        padding-right: 10 * @uw;
        margin-bottom: 20 * @uh;
        border-radius: 5 * @uw;

        .items {
            max-height: 1000 * @uh;
            overflow-y: auto;
        }

        .category-item {
            margin: 0px 8 * @uw 5 * @uh 8 * @uw;
            font-size: 14 * @uw;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 20 * @uw;
        }
    }
}

:deep(.el-collapse-item__header.is-active) {
    font-size: 16 * @uw;
    color: #8d5e1a;
}
</style>
